// @flow
import type { AxiosPromise, AxiosInstance } from "axios";

const uploadPhoto = (
  listingId: number,
  file: any,
  type: "listing" | "user",
  tag: null | "ev" = null
): ((apiInstance: AxiosInstance) => AxiosPromise<>) => (apiInstance) => {
  const formData = new FormData();
  formData.append("photo", file);

  formData.append("type", type);

  if (tag) {
    formData.append("tag", tag);
  }
  return apiInstance.post(`/v5/photos`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

export default uploadPhoto;
